








































































import AbpBase from "../../../lib/abpbase";
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import {GetRecipeData,Prescribe,GetSpecialNurseItems,GetSystemTemplateDic,SaveSpecialNurse,GetSpecialNurses,DeleteSpecialNurse} from '../../../api/dialysisProcess'

import {GetListByCode} from '../../../api/configureDictionary/'
import uploadImg from '../../../components/upload/dialysisBeginUploadImg.vue'


@Component({
    components:{
        uploadImg
    }
})
export default class  extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;

    //左右tabs
    tabsShow = 1

    piclist:any = {}
    picConfirm(){
        
    }
    nurseType = '全部'
    form:any = {
        recipeId:null,
        recordTime:new Date(),
        nurseItemId:null,
        quantity:null,
        templateId:null,
        id:null,
    }
    created() {
        this.getSpecialNurseItems()
        this.getSystemTemplateDic()
        this.getData()
    }
    nursesOptions:any = []
    nursesChecks:any = []
    //
    nurseItems:any = []
    //获取护理项目
    async getSpecialNurseItems(){
        let data = {}
        let res = await GetSpecialNurseItems(data)
        this.nursesOptions = res.objects
    }
    templateDic:any = []
    //获取护理小项
    async getSystemTemplateDic(){
        let data = {
            type:'001'
        }
        let res = await GetSystemTemplateDic(data)
        this.templateDic = res.objects
    }
    nursesChange(){
        let oldnurseItems = this.nurseItems;
        this.nurseItems = []
        this.nursesChecks.forEach((item:any)=>{
            let oldItem = oldnurseItems.find((v:any)=>{return v.id==item});
            this.nurseItems.push({
                id:this.nursesOptions.find((v:any)=>{return v.itemId==item}).itemId,
                name:this.nursesOptions.find((v:any)=>{return v.itemId==item}).itemName,
                quantity:oldItem?oldItem.quantity:1,
                content:oldItem?oldItem.content:'',
                templateId:oldItem?oldItem.templateId:null,
                unit:this.nursesOptions.find((v:any)=>{return v.itemId==item}).unit,
                unitName:this.nursesOptions.find((v:any)=>{return v.itemId==item}).unitName,
            })
        })
        console.log(this.nurseItems)
    }
    dicChange(val:any){
        this.nurseItems.forEach((item:any) => {
            if(item.templateId == val){
                item.content = this.templateDic.find((v:any)=>{return v.id==val}).content;
            }
        });
    }

    async save(){
        console.log(this.nurseItems)
        let data = this.form
        if(!data.id){
            delete data.id
        }
        data.recipeId = this.data.recipeId;
        let nurseItemIds = this.nurseItems.map((item:any)=>{return item.id});
        data.nurseItemId = nurseItemIds.join(',');
        let quantitys = this.nurseItems.map((item:any)=>{return item.quantity});
        data.quantity = quantitys.join(',');
        let templateIds = this.nurseItems.map((item:any)=>{return item.templateId});
        data.templateId = templateIds.join(',');
        data.recipeId = this.data.recipeId;
        let res = await SaveSpecialNurse(data)
        if(res.status == 1){
            this.$emit('input',false);
            this.$emit('on-back')
        }
    }
    list:any = []
    tableLoading:boolean = false
    async getData(){
        this.tableLoading = true
        let data = {
            RecipeId:this.data.recipeId
        }
        let res = await GetSpecialNurses(data)
        this.list = res.objects
        this.nurseItems = []
        this.tableLoading = false
    }
    nurseEdit(row:any){
        //编辑
        this.form.id = row.id
        let nurseItemIds = row.nurseItemId.split(',')
        let quantitys = row.quantity.split(',')
        let template = row.template.split(',')
        let templateIds = row.templateId.split(',')
        nurseItemIds.forEach((item:any,index:any) => {
            this.nurseItems.push({
                id:nurseItemIds[index],
                name:this.nursesOptions.find((v:any)=>{return v.itemId==nurseItemIds[index]}).itemName,
                quantity:Number(quantitys[index]),
                content:template[index],
                templateId:Number(templateIds[index]),
                unit:this.nursesOptions.find((v:any)=>{return v.itemId==nurseItemIds[index]}).unit,
                unitName:this.nursesOptions.find((v:any)=>{return v.itemId==nurseItemIds[index]}).unitName,
            })
        });
        this.nursesChecks = nurseItemIds.map((item:any)=>{return Number(item)})
        console.log(this.nurseItems)
    }
    async nurseDelete(row:any){
        let res = await DeleteSpecialNurse({Id:row.id})
        if(res.status == 1){
            this.getData()
        }
    }
    column = [
        {
            title:'记录时间',
            key:'recordTime'           
        },
        {
            title:'创建人',
            key:'creatorUser'           
        },
        {
            title:'内容',
            key:'content'           
        },
        {
            title:'备注',
            key:'remarks'           
        },
        {
            title: this.L('Actions'),
            key: 'Actions',
            width: 160,
            render: (h: any, params: any) => {
                return h('div', [
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small'
                        },
                        style: {
                            marginRight: '5px'
                        },
                        on: {
                            click: () => {
                                this.nurseEdit(params.row)
                            }
                        }
                    }, '编辑'),
                    h('Button', {
                        props: {
                            type: 'error',
                            size: 'small'
                        },
                        style: {
                            marginRight: '5px'
                        },
                        on: {
                            click: () => {
                                this.nurseDelete(params.row)
                            }
                        }
                    }, '删除'),
                ])
            }
        }
    ]
    cancel(){
        (this.$refs.roleForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dialysisProcess/dialysisArea/specialCare.vue